export default "__VITE_ASSET__B_jaBxT3__"